import { atom, useAtom } from 'jotai/index';

import { NFTImage } from '../types';

const nftImagesAtom = atom<Map<string, NFTImage>>(new Map());

export type NftImagesStore = {
  nftImages: Map<string, NFTImage>;
  saveNft: (nftImage: NFTImage) => void;
};

export const useNftImages = () => {
  const [nftImages, setNftImages] = useAtom(nftImagesAtom);

  return {
    nftImages,
    saveNft: (image: NFTImage) => setNftImages(nftImages.set(image.id, image)),
  };
};
